import "./Testimonial.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import button from "../../progressiveapp/assetsprogressive/button.png";
import symbol from "../../progressiveapp/assetsprogressive/symbol.png";
import f1 from "../../progressiveapp/assetsprogressive/pic1.png";
import f2 from "../../progressiveapp/assetsprogressive/pic2.png";
import f3 from "../../progressiveapp/assetsprogressive/pic3.png";
import f4 from "../../progressiveapp/assetsprogressive/pic4.png";
const Testimonial = () => {
  const data = [
     {
       id: 1,
       image: f1,
       name: "Rahul Sharma",
       position: "—  Founder, Web3 Startup",
       feedback:
         "The NFT marketplace was delivered exactly as planned. The team demonstrated strong technical expertise and clear communication throughout the project.",
     },
     {
       id: 2,
       image: f2,
       name: "Amit Patel",
       position: "– CTO, Digital Solutions Firm",
       feedback:
         "Expertise in blockchain and NFTs helped shape a marketplace that is both robust and high-performing. The platform’s UI/UX and overall stability surpassed our initial benchmarks.",
     },
     {
       id: 3,
       image: f3,
       name: "Priya Nair",
       position: "– Operations Head, Blockchain Startup",
       feedback:
         "After launch, the support was prompt and dependable, allowing us to scale the platform efficiently. Highly recommended for teams focused on building robust Web3 solutions.",
     },
    //  {
    //    id: 4,
    //    image: f4,
    //    name: "Nikhil Verma",
    //    position: "— Bengaluru, India",
    //    feedback:
    //      "Clear technical direction and thoughtful execution helped us avoid common scaling issues. The team focused on building a product that performs reliably in real-world usage, not just on paper.",
    //  },
   ];
  const settings = {
    dots: false,
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    cssEase: "ease-in-out",
    nextArrow: <img src={button} alt="Next" className="nextArrow" />,
    prevArrow: <img src={button} alt="Previous" className="prevArrow" />,
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };
  return (
    <div id='marketplace-testimonials' className="progressive-wrapper">
       <div className="container-main">
            <h2 className="heading">
          Testimonials
            </h2>
            {/* <p className="subHeading">
            We build trust through proven client experiences, delivering reliable CRM solutions that drive measurable results and long-term business growth.
            </p> */}
            <Slider {...settings}>
                {data.map((item) => {
                    return (
                        <div className="fwrapper" key={item.id}>
                            <div className="fbox">
                                <div className="symbolbox">
                                    <img src={symbol} alt="" className="symbolimage" />
                                </div>
                                <div className="fcontent">
                                    <p>{item.feedback}</p>
                                    <div className="personinfo">
                                        <h3>{item.name}</h3>
                                        <h4>{item.position}</h4>
                                    </div>
                                </div>
                                <div className="profilebox">
                                    <img src={item.image} alt="" className="profileimage" />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </Slider>
    </div>
</div>
  );
};

export default Testimonial;
